import { render, staticRenderFns } from "./investigator-list.vue?vue&type=template&id=8dffd1ea&"
import script from "./investigator-list.vue?vue&type=script&lang=js&"
export * from "./investigator-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports